<template>
<v-container fluid>
    <div style="text-align:right">
        <a target="_blank" :href="manualLink" text-right>คู่มือการใช้งาน</a>
    </div>
    <v-card class="ma-2" flat>
        <v-card-title>
            รายโปรแกรม 
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            <v-btn color="primary" dark class="ml-5 mt-3" @click="addNewItem" v-if="isAccessCoachAdmin">
                + ADD
            </v-btn>
        </v-card-title>

        <!-- Dialog for confirm delete user -->
        <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
            <v-card>
                <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                <v-card-actions v-if="dialogItem.confirmAction">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-actions v-else>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="actionDeleteItem">Yes</v-btn>
                    <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- table list @click:row="goToProgramView"  `/program/program-list/view/${item.id}` -->
        <v-data-table :headers="headers" :items="itemList" :search="search" sort-by="name" :sort-desc="false" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading" @click:row="goToProgramView">
            <template v-slot:[`item.activityCount`]="{ item }">
                {{ _formatData('number', item.activityCount) || 0 }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon class="mr-2" @click="goToProgramView(item)" :href="getProgramViewUrl(item)" title="View" >
                    <v-icon >
                        mdi-calendar-multiselect
                    </v-icon>
                </v-btn>
                <v-btn icon class="mr-2" @click="editItemAction(item)" :href="getItemUrl(item)" title="Edit" v-if="item.allowToManage">
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
                <v-btn icon class="mr-2" @click="dialogDeleteItem(item)" title="Delete" v-if="item.allowToDelete">
                    <v-icon>
                        mdi-delete
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import bqGetProgramList from "../data/bqGetProgramList";
import removeProgram from "../data/removeProgram";
import formatData from "../utils/formatData";
export default {
    metaInfo: {
        title: 'Program list'
    },
    data() {
        return {
            manualLink: "https://www.thaisook.org/wp-content/uploads/2023/03/คู่มือการใช้งานระบบไทยสุข-PILM-สำหรับโค้ช.pdf",
            loading: true,
            search: "",
            options: {
                itemsPerPage: 20,
            },
            owner: false,
            headers: [{
                    text: "Name",
                    value: "name"
                },
                {
                    text: "หน่วยงาน",
                    value: "Org"
                },
                {
                    text: "Coach",
                    value: "coach_name"
                },
                {
                    text: "Members",
                    value: "member_count"
                },
                {
                    text: "จำนวนกิจกรรมเฉลี่ย",
                    value: "activityCount"
                },
                {
                    text: "จำนวนครั้ง onsite",
                    value: "onsiteCount"
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
            itemList: [],

            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to delete this program?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to delete this program?",
                deleteConfirmation: false,
                deletedItemId: null,
            }
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.uid = this.$route.params.uid != undefined ? this.$route.params.uid : this.loggedInUserId;
    },
    computed: {
        ...mapGetters([
            "loggedInUserId",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin",
            "isAccessPILMAdmin"
        ]),
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isAccessCoachAdmin || this.isAccessOrgAdmin) {
                (async () => {
                    this.loading = true;
                    if( this.isSuperAdmin || this.isAccessPILMAdmin ){
                        this.itemList = await bqGetProgramList( );    
                    }
                    else{
                        this.itemList = await bqGetProgramList( this.uid );
                    }

                    if (this.itemList.length) {
                        await Promise.all(
                            this.itemList.map(async (item) => {
                                item.allowToManage = false;
                                item.allowToDelete = false;
                                if( (item.owner == this.loggedInUserId || this.isSuperAdmin || this.isAccessPILMAdmin) ){
                                    item.allowToManage = true;
                                    if( !item.member_count ){
                                        item.allowToDelete = true;
                                    }
                                }
                                
                            })
                        );
                    }
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        // //dialog
        addNewItem() {
            this.$router.push(`/program/program-list/add`);
        },
        getItemUrl(item){
            return `/program/program-list/edit/${item.id}`;
        },
        editItemAction(item) {
            this.$router.push(this.getItemUrl(item));
        },

        // //delete
        dialogDeleteItem(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedItemId = item.id; //assign delete item id
            this.dialogItem.confirmAction = false;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteItem() {
            (async () => {
                await removeProgram(this.dialogItem.deletedItemId);
                this.dialogItem.confirmAction = true;
                this.dialogItem.confirmText = "Done!";

                //await this.initialize();
                let itemListTmp = [];
                for (var i = 0; i < this.itemList.length; i++) {
                    if (this.itemList[i].id != this.dialogItem.deletedItemId) {
                        itemListTmp.push(this.itemList[i]);
                    }
                }
                this.itemList = itemListTmp;
                this.dialogItem.deleteConfirmation = true;
                this.dialogItem.confirmAction = true;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        getProgramViewUrl(item){
            return `/program/program-list/view/${item.id}`;
        },
        goToProgramView(item) {
            if( !this.dialogItem.deleteConfirmation ){
                this.$router.push(this.getProgramViewUrl(item));
            }
        },
        _formatData(type, value) {
            if (!value) return null;
            return formatData(type, value);
        },
    },
};
</script>
